import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserRoundPlus, X } from "lucide-react";
import api, { visitorId } from "../lib/api";
import { track } from "../lib/track";

const DISMISS_KEY = "cc_claim_cta_dismissed";

/* Iter 70 experiment (claim_cta_v1): treatment arm only, dismissible, never blocks job search/details/apply. */
export const ClaimCta = ({ jobId }) => {
  const nav = useNavigate();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const vid = visitorId();
    if (!jobId || !vid || localStorage.getItem(DISMISS_KEY)) return;
    let cancelled = false;
    api.get(`/public/experiments/claim-cta/assign?vid=${encodeURIComponent(vid)}&job_id=${encodeURIComponent(jobId)}`)
      .then(({ data }) => {
        if (cancelled || !data?.eligible) return;
        api.post("/public/experiments/claim-cta/event", { vid, event: "exposure", job_id: jobId }).catch(() => {});
        if (data.arm === "treatment") setShow(true);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [jobId]);

  if (!show) return null;
  const vid = visitorId();
  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    api.post("/public/experiments/claim-cta/event", { vid, event: "dismiss", job_id: jobId }).catch(() => {});
    setShow(false);
  };
  const go = () => {
    api.post("/public/experiments/claim-cta/event", { vid, event: "cta_click", job_id: jobId }).catch(() => {});
    track("coach_cta_click", { via: "claim_cta_v1", job_id: jobId });
    nav("/coaches/find");
  };
  return (
    <aside data-testid="claim-cta-card" className="mt-6 border border-neutral-800 bg-appcard/80 p-4 flex items-start gap-3 relative">
      <button type="button" onClick={dismiss} aria-label="Dismiss" data-testid="claim-cta-dismiss"
        className="absolute top-2 right-2 text-neutral-500 hover:text-white p-1 min-w-[32px] min-h-[32px] flex items-center justify-center">
        <X size={14} />
      </button>
      <UserRoundPlus size={18} className="text-blaze mt-0.5 shrink-0" />
      <div className="pr-6">
        <div className="heading text-base md:text-lg" data-testid="claim-cta-title">CLAIM YOUR FREE COACHING PROFILE</div>
        <p className="text-sm text-neutral-400 mt-1" data-testid="claim-cta-copy">Build your career history and coaching connections.</p>
        <button type="button" onClick={go} data-testid="claim-cta-button"
          className="mt-3 inline-flex items-center gap-2 bg-blaze text-white heading text-sm px-4 py-2.5 hover:glow-blaze transition-all min-h-[44px]">
          FIND MY PROFILE
        </button>
      </div>
    </aside>
  );
};
